import type { FaireProductEntity } from "../../entity_types/product";

export const p_8jpss9zd35: FaireProductEntity = {
  token: "p_8jpss9zd35",
  type: "product",
  name: "Y2K TRIBAL FULL ZIP HOODIE",
  brandToken: "b_kmqjsus8ac",
  brandName: "First Row",
  imageUrl:
    "https://cdn.faire.com/fastly/735fb21d6d90dd58cbf7706c1f3d59eae8a114e53d89e298f50c3aef2878e7a6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/28fe979f2718f392134d9c0a46d03394808ed7cdcc20a5c85cdc6e2c3fa3694e.jpeg",
    "https://cdn.faire.com/fastly/394d118588498760bc8c7371a81d15e50682c677eb426c682b495a6c7884d075.jpeg",
    "https://cdn.faire.com/fastly/e94984cc1ec38835614639ad5e56363aab0604163f5bec19a3afd81ce1c9f7d4.jpeg",
    "https://cdn.faire.com/fastly/8ac3284aeb81bf17151685029c7171bcd5ad862294d7a91dcfd718e3279236fb.jpeg",
    "https://cdn.faire.com/fastly/19b60252d10fbe5d3214ded4ad5794d79d07ebe6108b32a107f1274e4690fa33.jpeg",
    "https://cdn.faire.com/fastly/bf704f941afe6f9e307a83f94074f71ea1787c79eb5d54a0ed00892618649647.jpeg",
    "https://cdn.faire.com/fastly/34e3a1da9bf82ee2c6bcc1f592e6f21d55622ab6b9a766907b86f6b268372892.jpeg",
    "https://cdn.faire.com/fastly/ba79d9e81eb0c9d8696f491f9e387b61107ae159e2e6d06477fd4cd33eff632b.jpeg",
  ],
  priceDollars: 332.57,
  description:
    'A washed full zip up hoodie featuring metalic effect, drawstring hoodie, front kanga pocket and zip-fly closure.\n\nSIZE M /  CHEST(HALF MEASURE) 27" /  FRONT BODY  LENGTH 25 1/2" / SLEEVE 23 3/4"\n\n',
  tags: [],
  msrpDollars: 665.13,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:56.472Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
